export default "__VITE_ASSET__DsraWaFj__"